import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '../services/globals.service';
import { BaseBus } from '../models/BaseBus';

import { UntypedFormGroup } from '@angular/forms';
import { CommonFunctions } from '../static/common-functions';
import { SearchTarget } from '../enums/SearchTarget';
import * as _ from 'lodash';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '../models/DQOIReferenceData';
import { GItem } from '../models/GItem';
import { SelectEvent, TabStripTabComponent, TabStripComponent } from '@progress/kendo-angular-layout';
import { BasePage } from '../models/BasePage';
import { MatExpansionPanel } from '@angular/material/expansion';
import { GeographyInfoBus } from '../models/GeographyInfoBus';
import { MessageType } from '../enums/MessageType';
import { BusinessObjectFactory } from '../models/BusinessObjectFactory';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { Message } from '../models/message';
import { SaveMode } from '../enums/SaveMode';
import { CRUDActions } from '../enums/CRUDActions';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { CommonValues } from '../static/CommonValues';
import { ConfirmOutput } from '../models/ConfirmOutput';
import { CPDialogResult } from '../enums/CPDialogResult';
import { DateFunctions } from '../static/date-functions';
import { MessageInfoDialogComponent } from '../components/message-info-dialog/message-info-dialog.component';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { MessageInfoShow } from '../models/MessageInfoShow';
import { DbTable } from '../enums/DbTable';
import { WindowContents } from '../enums/windowContents';
import { DispatchData } from '../models/DispatchData';
import { MessageInfoType } from '../enums/MessageInfoType';
import { BaseDQOIComponent } from './base-dqoi.component';
import { CommonParam } from '../models/CommonParam';
import { DQOICParam } from '../models/DQOICParam';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '../models/UsersBus.model';
import { AppClaims } from '../models/AppClaims';
import { validateOverridables, EmptyOverridable } from '../decorators/overridable/base-method-override-decorator';

@Component({
    selector: '',
    template: ''
})
export class BaseAppMComponent<T extends BaseBus, S, A extends BaseBus, P extends BasePage<S>> implements OnInit, OnChanges, AfterViewInit, OnDestroy {

    private authServiceInternal: CmProAuthService = inject(CmProAuthService);
    constructor(public globals: GlobalsService, protected featureFlagService: FeatureFlagService, qry_rd: DQOIReferenceDataQuery) {
        this.appCode = "Inventory Transfer";
        this.qry_rd = qry_rd;
        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseAppMComponent);
    }

    @EmptyOverridable()
    customSetId() { }

    @EmptyOverridable()
    customReferenceData() { }

    @EmptyOverridable()
    setDefaultFocus() { }

    @EmptyOverridable()
    onTabSelect(e: SelectEvent, refreshData: boolean = false) { }

    @EmptyOverridable()
    getAddtlData() { }

    @EmptyOverridable()
    afterDataSet() { }

    @EmptyOverridable()
    setForm() { }

    @EmptyOverridable()
    delete() { }

    @EmptyOverridable()
    saveIndividual() { }

    @EmptyOverridable()
    saveAll() { }

    @EmptyOverridable()
    panelExpand(e: any) { }

    /**
    * @deprecated This customParentMessage is deprecated and will be removed in future versions. Deprecated on: 05.20.2025. Override parentMessage instead.
    */
    @EmptyOverridable()
    customParentMessage(e: Message) { }

    @EmptyOverridable()
    confirmCustom(data: ConfirmOutput) { }

    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    @ViewChild('miDialog') protected miDialog: MessageInfoDialogComponent;
    @ViewChild("mainTab") mainTab: TabStripComponent;

    @Input() parentId: any;
    subs_data: Subscription;
    appCode: string = null;
    private _rights: AppClaims | null = null;
    virtualizationSettings = CommonValues.virtualizationSettings;

    /**
     * Using this getter can cause race conditions in code depending on how this is used.
     * While we have a user data  resolver in place to help, this still could cause issues.
     * If you need reliable data from the user object, use CmProAuthService.subscribeToLoginEvents and CmProAuthService.unsubscribeToLoginEvents in your component
     *
     * @readonly
     * @type {AppClaims}
     * @memberof BaseAppMComponent
     */
    get rights(): AppClaims {
        return this._rights ?? this.globals.user?.appClaims ?? new AppClaims();
    }

    set rights(value: AppClaims) {
        this._rights = value;
    }

    @Input() set Id(id: any) {
        if (CommonFunctions.hasValue(id)) {
            this.customSetId();
            this.getDataFromId(id);
        }
        else {
            this.clear();
        }
    }
    @Input() common: CommonParam;
    protected get hasCommon(): boolean {
        return CommonFunctions.hasValue(this.common);
    }
    protected getCommon() {
        if (!this.hasCommon) {
            this.common = new CommonParam();
        }
        return this.common;
    }
    @Output() action: EventEmitter<DQOICParam> = new EventEmitter<DQOICParam>();
    @Output() outParentMessage: EventEmitter<Message> = new EventEmitter<Message>();
    subs_formChanged: Subscription;
    ngAfterViewInit() {
        if (this.setFocus) {
            this.setFocus = false;
            this.setDefaultFocus();
        }
    }
    holdSetChanged: boolean = false;
    ngOnChanges() {
        if (this.hasEditForm) {
            this.subs_formChanged = this.editForm.valueChanges.subscribe(val => {
                this.SetChanged();
            });
        }
    }
    searchTarget: SearchTarget = SearchTarget.any;
    editForm: UntypedFormGroup;
    qry_rd: DQOIReferenceDataQuery;

    mainDataLoading: boolean = false;
    data: T;
    originalData: T;
    addtlData: A;
    addtlDataClass: string;
    addtlDataLoader: boolean = false;
    svc_data: S;
    pageData: P;
    public get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    id: any;
    protected _masterId: any;
    subs_dataAddInfo: Subscription;
    subs_dataSearchEvent: Subscription;
    subs_save: Subscription;
    readOnly: boolean = true;
    customerLocations: GItem[] = null;
    customerGeoLocations: GItem[] = null;
    settingFromDQOIState: boolean = false;
    billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    locationGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    shippingGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };

    customer: string;
    location: string;
    @Input() saveMode: any = SaveMode.individual;
    set: boolean = false;
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && CommonFunctions.hasArrayElementValue(this.referenceData.dispatchStatus) ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }
    pDataArr: GItem[];
    callCurrentTab() {
        if (this.mainTab && this.mainTab.tabs) {
            let currTab: TabStripTabComponent = this.mainTab.tabs.find(s => s.selected === true);
            if (currTab) {
                let e: SelectEvent = new SelectEvent(0, currTab.title);
                //e.title = this.mainTab.tabs[i].title;
                this.onTabSelect(e);
            }
        }
    }

    get hasEditForm(): boolean {
        return this.editForm !== undefined && this.editForm !== null ? true : false;
    }
    get hasData(): boolean {
        return this.data !== undefined && this.data !== null;
    }
    get hasAddtlData(): boolean {
        return CommonFunctions.hasValue(this.addtlData);
    }
    get canEdit(): boolean {
        return this.readOnly && this.hasData;
    }
    get childCanEdit(): boolean {
        return this.customFormValidation() && (this.saveMode == SaveMode.individual || !this.readOnly);
    }
    get canClear(): boolean {
        return this.readOnly && this.hasData;
    }
    get isDirty(): boolean {
        return !this.readOnly && this.hasEditForm && this.editForm.dirty;
    }

    private _canSaveValue: boolean = false;
    private updateCanSaveValue(): void {
        let okToSave: boolean = false;
        if (this.isDirty) {
            if (this.hasId) {
                okToSave = this.editForm?.valid && this.customFormValidation();
            }
            else {
                okToSave = this.editForm?.valid && this.customFormValidation();
            }
        }

        this._canSaveValue = okToSave || this._hasSaveError;
    }

    get canSave(): boolean {
        this.updateCanSaveValue();
        return this._canSaveValue;
    }

    /**
     * This is a property that is used to determine if the save operation has encountered an error.
     * This will control if the setPristine() method is called after the save operation.
     *
     * @protected
     * @type {boolean}
     * @memberof BaseAppMComponent
     */
    protected set hasSaveError(value: boolean) {
        if (this._hasSaveError !== value) {
            this._hasSaveError = value;
            this.updateCanSaveValue();
        }
    }
    private _hasSaveError: boolean = false;

    setDirty() {
        if (this.hasEditForm) {
            this.editForm.markAsDirty();
        }
    }
    setPristine() {
        if (this.hasEditForm) {
            this.editForm.markAsPristine();
        }
    }
    get hasId(): boolean {
        return this.hasData && this.data.hasId ? true : false;
    }
    get dataObjOrEditObj(): any {
        if (this.readOnly) {
            return this.data;
        }
        else {
            return this.editForm.value;
        }
    }
    customFormValidation() {
        return true; //this.hasCustomerLocation;
    }

    ngOnDestroy() {
        //This gets called in odd places that mess up subscriptions
        this.unsubscribe_getData();
        this.clear();
        CommonFunctions.unsubscribe(this.sub_userLoggedIn);
        CommonFunctions.unsubscribe(this.sub_ensureRefData);
    }
    private sub_ensureRefData: Subscription;
    private sub_userLoggedIn: Subscription;
    private _rightsInternal: AppClaims = new AppClaims();
    ngOnInit() {
        this.sub_ensureRefData = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe(() => {
            //This should work only cause we have a FF resolver that holds the route till loaded
            if (this.featureFlagService.latestFeatureFlagSet['old-tax-codes']) {
                this.customReferenceData();
            }
        });
        this.sub_userLoggedIn = this.authServiceInternal.userLoggedInEvent$.subscribe((user: UsersBus) => {
            if (user) {
                this._rightsInternal = user.appClaims;
                if (this._rightsInternal.DefaultEditMode) {
                    this.edit();
                }
            }
        });
    }

    getDataFromId(id: any) {
        this.id = id;
        this.getData();
    }
    unsubscribe_getData() {
        CommonFunctions.unsubscribe(this.subs_data);
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        CommonFunctions.unsubscribe(this.subs_save);
        CommonFunctions.unsubscribe(this.subs_formChanged);
    }
    getBlankAddtlData() {
        this.addtlData = this.createNewAdditionalData();
    }

    getData() {
        this.getAddtlData();
    }

    setData(data: T) {
        this.data = this.createNew(data);
        this.clone();
        this.afterDataSet();
        this.setForm();
        this.callCurrentTab();
    }

    createNewAdditionalData(): A {
        let busObj: A = BusinessObjectFactory.Create(this.addtlDataClass, null);
        busObj.initialize(null);
        return busObj;
    }
    setNewDefaults() {
        this.data.setNew(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        this.addtlData = this.createNewAdditionalData();
    }
    new() {
        this.setFocus = true;
        this.clear();
        this.setNewDefaults();
        this.setData(this.data);
        this.edit();
        //this.setDefaultFocus();
        this.clone();
    }
    clone() {
        this.originalData = _.cloneDeep(this.data);
    }
    setFocus: boolean = false;
    protected edit?(): void {
        this.readOnly = false;
    }
    editOff() {
        if (!this._rightsInternal.DefaultEditMode) {
            this.readOnly = true;
        }
    }
    createNew(busObj: T): T {
        let obj = {} as T;
        if (obj.initialize) {
            obj.initialize(busObj);
        }
        return obj;
    }

    cancel() {
        let data = this.createNew(this.originalData);
        if (!this.data.hasId) {
            this.clear();
            this.customerLocations = [];
            this.customerGeoLocations = [];
        }
        this.data = data;
        this.setForm();
        this.setPristine();
        this.editOff();
        this.cancelChildren();
        this.refreshData(null);

    }
    protected cancelChildren() {
        this.pageData.clear();
        this.getAddtlData();
    }
    reduceToMinData() {
        if (CommonFunctions.hasValue(this.pageData)) {
            this.pageData.clear();
        }
    }
    clear() {
        this.data = this.createNew(null);
        this.originalData = this.createNew(null);
        this.id = null;
        this.customerLocations = [];
        this.customerGeoLocations = [];
        this.readOnly = true;
        if (this.hasEditForm) {
            this.editForm.reset();
        }
        if (CommonFunctions.hasValue(this.pageData)) {
            this.pageData.clear();
        }
        if (CommonFunctions.hasValue(this.addtlData)) {
            this.addtlData.clear();
        }
        if (this._rightsInternal && this._rightsInternal.DefaultEditMode) {
            this.edit();
        }
    }
    close() {
        this.clear();
    }
    trySave() {
        this.save();
    }

    save() {
        this.setForSave();
        if (this.saveMode === SaveMode.individual) {
            this.saveIndividual();
        }
        else {
            this.saveAll();
        }
        //NOTE: [dturco 03.15.2025] This is a bug, we need to be listening to the results of the SaveAll and SaveIndividual methods to determine if the save was successful or not before calling setPristine()
        this.setPristine();
    }

    get canDelete(): boolean {
        return true;
    }

    setForSave(): T {
        return null;
    }

    protected saveSuccess(message: string = null) {
        let not: string = this.appCode + " Successfully Saved" + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifySuccess(not);
        this.editOff();
    }
    protected saveError(message: string = null) {
        let not: string = "There was a problem saving " + this.appCode + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifyError(not, true);
    }
    protected deleteSuccess() {
        this.globals.notifySuccess(this.appCode + " Deleted Successfully!");
    }
    protected deleteError(message: string) {
        this.globals.notifyError("Delete Encountered an Error: " + message, true);
    }

    refresh(matExpansionPanel: MatExpansionPanel, event: Event, code: string) {
        event.stopPropagation();
        this.panelExpand(code);
    }
    afterSaveMessage: Message;
    setAfterSaveMessage(msg: Message) {
        this.afterSaveMessage = msg;
    }

    protected SetChanged() {
        if (!this.holdSetChanged) {
            this.setDirty();
            this.sendParentMessage(MessageType.changed);
            // Update the _canSaveValue when form changes
            this.updateCanSaveValue();
        }
    }

    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        let msg: Message = new Message();
        msg.messageType = type;
        msg.messageSubject = subject;
        msg.message = message;
        msg.values = values;
        msg.value = value;
        this.outParentMessage.emit(msg);
    }
    parentMessage(e: Message) {
        if (e.messageType === MessageType.saveParent) {
            this.save();
        }
        else if (e.messageType === MessageType.changed) {
            if (this.saveMode === SaveMode.all) {
                this.SetChanged();
            }
        }
        else if (e.messageType === MessageType.refresh) {
            this.refreshData(e.refreshTarget);
        }
        else if (e.messageType === MessageType.messageInfo) {
            let info = new MessageInfoShow(e.values[0] as MessageInfoShow);
            this.miShow(info.message, info.messageInfo, info.data, info.title, info.code);
        }
        else if (e.messageType === MessageType.msgPopup) {
            this.cnfShowSomeGeneralMessage(e.message, e.messageSubject);
        }
        else if (e.messageType === MessageType.goTo) {
            let data: DispatchData = new DispatchData();
            data.viewDispatch.dispatchId = e.value;
            data.id = e.value;
            this.dqoiPopup(data, SearchTarget.order);
        }
        else {
            this.customParentMessage(e);
        }

    }
    dqoiPopup(data: DispatchData, target: SearchTarget) {
        data.target = target;
        data.isConstruction = false;
        this.dqoiWindowData = data;
    }
    public dqoiWindowData: DispatchData;
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    onCPWindowClosed(e) {
        this.cpShowWindow = false;
    }

    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget) && this.mainTab?.tabs) {
            let index: number = -1;
            this.mainTab.tabs.forEach((tab: TabStripTabComponent) => {
                index++;
                if (tab.selected === true) {
                    var event: SelectEvent = new SelectEvent(index, tab.title);
                    this.onTabSelect(event, true);
                }

            });
        }
    }

    refreshRefferenceData(input: ConfirmOutput) {
        this.qry_rd.forceRefresh(this.globals.companyId);
    }
    deleteDialog(data: T) {
        this.cnfShow(CommonValues.Message_AreYouSureYouWantToDeleteThis, CRUDActions.Delete, data);
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    handled = true;
                    this.delete();
                    break;
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }
    }

    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = false) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly);
        }
    }
    cnfShowSomeGeneralMessage(message: string, title: string = "") {
        this.cnfShow(message, CRUDActions.None, null, title, null, true);
    }

    miShow(message: string, info: BaseMessageInfo, data: any = null, title: string = null, code: string = null, okButtonText: string = "Ok", type: MessageInfoType = MessageInfoType.general) {
        if (CommonFunctions.hasValue(this.miDialog)) {
            this.miDialog.show(message, info, data, title, code, okButtonText, type);
        }
    }
}

